import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { addLab} from "./LabServices";
import { formFields, validationSchema } from "./LabSchema";
import LabTable from "../../components/common/Model/LabTable";

export const LabAdd = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                                    <Box component="div" sx={{ mt: 2 }}>
                                        <PageHeader header="Add Lab" />
                                        {/* <CMForm
                                            validationSchema={validationSchema}
                                            formFields={formFields}
                                            addService={addLab}
                                            listPageKey='LAB_LIST'
                                        />  */}
                                        <LabTable/>
                                    </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
